/**
 * Component to render question info to the user
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
import classNames from 'classnames';
import renderHTML from 'react-render-html';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import VideoPlayer from "../../../global/components/helpers/VideoPlayer.js.jsx";

// import utilities
import richContentUtils from '../../../global/utils/richContentUtils';
import videoUtils from "../../../global/utils/videoUtils.js";

class QuestionVideo extends Base {
  constructor(props) {
    super(props);
  }


  shouldComponentUpdate(nextProps) {
    /**
     * ISSUE: video component re-renders a bunch of times on slow loads, flickering the screen
     *  this is happening because its complicated and slow to render, NOT because it's rendering too many times
     * it re-renders on any prop change. however, we can force it to only render under certain conditions
     * in practice, i THINK only the last one necessary (fetching one). but something like this can cause unintended behavior so it's better to be careful.
     * https://reactjs.org/docs/react-component.html#shouldcomponentupdate
     *
     * TESTING: comment out this entire method to test without it
    */

    const update =
      nextProps.courseId !== this.props.courseId
      || nextProps.evaluationId !== this.props.evaluationId
      || nextProps.contentModuleId !== this.props.contentModuleId
      || nextProps.question._id !== this.props.question._id
    ;
    return update;

  }


  render() {
    const {
      autoPlay
      , courseId
      , evaluationId
      , handleReady
      , location
      , match
      , openFollowups
      , question
      , contentModuleId
      , viewAs
    } = this.props;

    const playlist = question ? videoUtils.returnPlaylist(question.videoPath, question.posterPath, question.tracks) : [];
    let videoClass = classNames(
      '-video'
    )

    return (
      <div className="question-wrapper">
        <div className="-question-video-wrapper">
          <div className={videoClass}>
            { viewAs === 'user' ?
              <VideoPlayer
                isAutoPlay={autoPlay}
                onComplete={this._onVideoComplete}
                handleReady={handleReady}
                playerId={question._id + '-question-video'}
                playlist={playlist}
                tracking={{
                  _course: courseId
                  , _evaluation: evaluationId
                  , _contentModule: contentModuleId
                  , _question: question._id
                  , description: 'user-question'
                }}
              />
              :
              <VideoPlayer
                isAutoPlay={true}
                onComplete={this._onVideoComplete}
                playerId={question._id}
                playlist={playlist}
              />
            }
          </div>
        </div>
      </div>
    )
  }
}

QuestionVideo.propTypes = {
  autoPlay: PropTypes.bool
  , courseId: PropTypes.string
  , evaluationId: PropTypes.string
  , handleReady: PropTypes.func.isRequired
  , question: PropTypes.object.isRequired
  , contentModuleId: PropTypes.string
  , viewAs: PropTypes.string
}

QuestionVideo.defaultProps = {
  autoPlay: true
  , courseId: null
  , evaluationId: null
  , contentModuleId: null 
  , viewAs: 'user'
}

export default withRouter(QuestionVideo);



// WEBPACK FOOTER //
// modules/question/components/QuestionVideo.js.jsx